export default function urlHelper(uri) {
  return `${window.GIO_CONFIG.API_URL}/${uri}`;
}

export function urlHelperGioCore(uri) {
  return `${window.GIO_CONFIG.API_V2_URL}/${uri}`;
}

export function urlHelperGioApi(uri) {
  return `${window.GIO_CONFIG.GIO_API_URL}/${uri}`;
}

export function generateSiteURL(url, token) {
  const tokenEncoded = btoa(JSON.stringify({ token }));
  return `${url}/#/sso/${tokenEncoded}`;
}

export function generateGioDataURL(token) {
  const tokenEncoded = btoa(JSON.stringify({ token }));
  return `${window.GIO_CONFIG.SITE_URL}/#/sso/${tokenEncoded}`;
}
